import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { NetworkDetailInitStepDeclaration } from "./Steps/NetworkDetailInitStep";

export const NetworkDetailStartupFlow = new FlowDefinition("NetworkDetailFlow");

NetworkDetailStartupFlow.addStep(NetworkDetailInitStepDeclaration);

NetworkDetailStartupFlow.setStartStep("NetworkDetailInit_Step");

export const NetworkDetailStartupStepDefinition = new StepDefinition({
    stepName: "NetworkDetailFlow",
    stepFlow: NetworkDetailStartupFlow,
    contextIsolation: false
})